import create from 'utils/command'
import {associate} from 'utils/functions' 
import { getVideos } from 'external/youtube'

const hooks =  [
  {paths: ['refreshData', 'items/dashboardVideos/', 'props/params/pageName' ], resolves: [fetchVideos]}
]


export {hooks as default}

export async function refreshSettings({update}) {
  const items = await create('web', 'settings')({Prefix: 'student-client'}).then(associate('name', 'value'))
  update({items: {$set: items}})
}

export async function fetchVideos({ state, update }){
  const isValidPage = ['videos', 'dashboard'].indexOf(state.props.params.pageName) >= 0
  if (!isValidPage) return
  const { dashboardVideos } = state.items
  if (!dashboardVideos) return
  const loadVideos = (loading, videos) => ({videos: { loadingVideos: {$set: loading}, videos: {$set: videos}}})
  await update(loadVideos(true, []))
  const videos = await getVideos(dashboardVideos)
  update(loadVideos(false, videos))
}
